import { CgSpinner } from "react-icons/cg";

const Widget = ({ message }) => {
  return (
    <section
      id="loading-widget"
      className="loading-widget"
    >
      <CgSpinner className="animate-spin" />
      <p>{message}</p>
    </section>
  );
};

export default Widget;